// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sNsFXx6TATYQ28zhqvSy {
  position: fixed;
  z-index: 2147483647;
  background: #fff;
  border: 1px solid rgba(229, 231, 235, 0.9);
  border-radius: 12px;
  padding: 16px 20px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  min-width: 200px;
  pointer-events: none;
}

.UcFvSW5E7gDdglLqZA13 {
  font-size: 12px;
  font-weight: 400;
  letter-spacing: -0.02em;
  color: var(--sl-fg-base-soft, #707070);
  margin-bottom: 12px;
}

.wG_jT8UZlzWEJuaeGPz7 {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
}

.wG_jT8UZlzWEJuaeGPz7:last-child {
  margin-bottom: 0;
}

.Ps2tXEhkuSzq6SgUTEJQ {
  flex-shrink: 0;
  width: 8px;
  height: 8px;
  border-radius: 2px;
}

.IMwsVZ7IF49r7rOc_nTV {
  flex: 1;
  font-size: 11px;
  font-weight: 500;
  color: var(--sl-fg-base-soft, #707070);
}

.fBC_LcF1S3_kNF9jg5QL {
  font-size: 13px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  color: var(--sl-fg-base, #1f1f1f);
}

.C_NrH28GlRxEmS2uNxZR {
  margin-top: 8px;
  background: rgba(249, 250, 251, 0.8);
  border: 1px solid #f3f4f6;
  border-radius: 8px;
  padding: 8px 12px;
}

.rSsEpB5BBRQF0cCdvsCs {
  font-size: 11px;
  color: var(--sl-fg-base-soft, #707070);
  margin-bottom: 4px;
}

.NwM_uGfjHvse69RJxkob {
  font-size: 12px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  color: var(--sl-fg-base, #1f1f1f);
}
`, "",{"version":3,"sources":["webpack://./src/modules/retailMedia/components/BudgetConsumptionReport/SpendTooltip/styles.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,oCAAoC;EACpC,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,iCAAiC;AACnC","sourcesContent":[".tooltip {\n  position: fixed;\n  z-index: 2147483647;\n  background: #fff;\n  border: 1px solid rgba(229, 231, 235, 0.9);\n  border-radius: 12px;\n  padding: 16px 20px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);\n  min-width: 200px;\n  pointer-events: none;\n}\n\n.title {\n  font-size: 12px;\n  font-weight: 400;\n  letter-spacing: -0.02em;\n  color: var(--sl-fg-base-soft, #707070);\n  margin-bottom: 12px;\n}\n\n.row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 6px;\n}\n\n.row:last-child {\n  margin-bottom: 0;\n}\n\n.dot {\n  flex-shrink: 0;\n  width: 8px;\n  height: 8px;\n  border-radius: 2px;\n}\n\n.label {\n  flex: 1;\n  font-size: 11px;\n  font-weight: 500;\n  color: var(--sl-fg-base-soft, #707070);\n}\n\n.value {\n  font-size: 13px;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n  color: var(--sl-fg-base, #1f1f1f);\n}\n\n.forecastBand {\n  margin-top: 8px;\n  background: rgba(249, 250, 251, 0.8);\n  border: 1px solid #f3f4f6;\n  border-radius: 8px;\n  padding: 8px 12px;\n}\n\n.bandLabel {\n  font-size: 11px;\n  color: var(--sl-fg-base-soft, #707070);\n  margin-bottom: 4px;\n}\n\n.bandValues {\n  font-size: 12px;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n  color: var(--sl-fg-base, #1f1f1f);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tooltip": `sNsFXx6TATYQ28zhqvSy`,
	"title": `UcFvSW5E7gDdglLqZA13`,
	"row": `wG_jT8UZlzWEJuaeGPz7`,
	"dot": `Ps2tXEhkuSzq6SgUTEJQ`,
	"label": `IMwsVZ7IF49r7rOc_nTV`,
	"value": `fBC_LcF1S3_kNF9jg5QL`,
	"forecastBand": `C_NrH28GlRxEmS2uNxZR`,
	"bandLabel": `rSsEpB5BBRQF0cCdvsCs`,
	"bandValues": `NwM_uGfjHvse69RJxkob`
};
export default ___CSS_LOADER_EXPORT___;
